import request from '@/utils/request'

export function selectMaterialStock(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/materialStock/selectMaterialStock?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addMaterialInventory(data) {
    return request({
        url: `api/serviceCenter/materialStock/addMaterialInventory`,
        method: 'post',
        data,
    })
}

export function upDateMaterialInventory(data) {
    return request({
        url: `api/serviceCenter/materialStock/upDateMaterialInventory`,
        method: 'post',
        data,
    })
}

export function bathDeleteMaterialInventory(data) {
    return request({
        url: `api/serviceCenter/materialStock/bathDeleteMaterialInventory`,
        method: 'post',
        data,
    })
}







